import { enumEnvironmentName } from '@env/enumEnvironmentName';
import { getUrlConfig } from '@env/url-config';
import { EnvironmentModel } from '@env/environment-model';

export const prefixCustoms = 'https://eezy-customs-api-test.azurewebsites.net/api/';
export const prefixIdentity = 'https://eezy-identity-api-test.azurewebsites.net/api/';
export const prefixClient = 'https://eezy-client-test.azurewebsites.net';
export const prefixFreight = 'https://eezy-freight-api-test.azurewebsites.net/api/';
export const prefixInsurance = 'https://eezy-marine-insurance-api-test.azurewebsites.net/api/';
export const connector = 'https://eezy-identity-api-test.azurewebsites.net/connect/token';
export const provider = 'https://abiprovidertest.azurewebsites.net/api/';

export const environment: EnvironmentModel = {
  name: enumEnvironmentName.TEST,
  production: true,
  gtmId: 'GTM-MMC74PSR',
  useFbTracking: false,
  useGaTracking: true,
  appInsightsKey: 'b65c13d0-e714-4012-aa2d-24ae71cd36cb',
  url: getUrlConfig(prefixIdentity, prefixCustoms, prefixFreight, prefixInsurance, provider),
  alertTime: 5000,
  client_id: 'angular.application',
  client_secret: 'acde9bd0-5d12-45e1-81e6-c0f95ea31514',
  grant_type: 'password',
  poaFileURL: 'https://eezyimportcommonfiles.blob.core.windows.net/eezyimportpublic/power-attorney-customs.pdf',
  importCustomsFileURL:
    'https://eezyimportcommonfiles.blob.core.windows.net/eezyimportpublic/eezyimport-import-customs-data-example_2022-10-19.xlsx',
  freshchat: {
    token: '25860f70-e160-487a-ae7a-459b0cc38f67',
    host: 'https://wchat.freshchat.com',
  },
  cookieBotKey: 'ddc23eb7-c377-4b53-8f36-06f9459c5e5d',
  paypalEnv: 'sandbox',
  paypalAgreementUrl:
    'https://www.sandbox.paypal.com/agreements/approve?approval_session_id={{approvalSessionId}}&billingLite=1#/billingweb/review',
  ga: {
    viewId: '196408150',
    clientId: '430060957896-6epbrrgl3dtmudeu40l6hjebo6362ofk.apps.googleusercontent.com',
    allUsersSegmentId: 'gaid::-1',
    usaUsersSegmentId: 'users::condition::ga:country==United States',
  },
  reCaptchaV2: {
    // https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
    siteKey: '6LcsBq8ZAAAAAJ0_X5JDRE9oQ1Uprh1Q-3lT-DdH',
  },
  files: {
    default_file_size_limit: 5,
    import_file_size_limit: 30,
  },
  loans: {
    scriptSrc: 'https://sdk.demo.behalf.com/sdk/v4/behalf_payment_sdk.js',
    clientToken: 'IqXzVT0j',
  },
  bluesnapMerchantId: '1990952',
  gtmAuth: 'luRyVItTByb6CQPElmNIpw',
  gtmPreview: 'env-23',
  stripeKey: 'pk_test_51MLQw3JygLxI1uZyKvh1rFDWrf7gu2fCUbIJtNGARCmrvCTiKDlYY17FWl68F1vga8tU8tv4HAGNXvMkqXoyQhwY00yo6cFM8l',
  paypalClientId: 'AeKy012WpztCTOnJuMdOBdgfpEMlMsjnnOUQHwYvwFjJ0EuL8zopsWRDHbBnqUkTtGazPA6rkRV_xsVm',
};
